import { EChatImagesActionTypes } from '../../actions/chatImages';
import { TAppState, ERequestApiStatus } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export function chatImagesReducer(state: TAppState, action: TReduxActions): TAppState {
  // @ts-ignore
  const openedChat = action?.payload?.chatId && state.openedChats[action.payload.chatId];
  const files = openedChat?.images?.files || [];

  if (!openedChat) {
    return {
      ...state,
    };
  }

  switch (action.type) {
    case EChatImagesActionTypes.SetChatImagesPending:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...openedChat,
            images: {
              ...openedChat.images,
              status: ERequestApiStatus.Pending,
            },
          },
        },
      };

    case EChatImagesActionTypes.SetChatImagesSucceed:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...openedChat,
            images: {
              files:
                action.payload.files && action.payload.files?.images.length
                  ? action.payload.files.images.concat(files)
                  : files,
              page: { ...action.payload.page },
              status: ERequestApiStatus.Succeed,
            },
          },
        },
      };

    case EChatImagesActionTypes.SetChatImagesFailed:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...openedChat,
            images: {
              ...openedChat.images,
              status: ERequestApiStatus.Failed,
            },
          },
        },
      };

    case EChatImagesActionTypes.SetChatImagesEmpty:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          [action.payload.chatId]: {
            ...openedChat,
            images: null,
          },
        },
      };

    default:
      return state;
  }
}
